import { useEffect, useState } from 'react'

/** Tailwind default breakpoints */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS | 'xs'

function getBreakpoint(width: number): BreakpointKey {
  if (width >= BREAKPOINTS.xl) return 'xl'
  if (width >= BREAKPOINTS.lg) return 'lg'
  if (width >= BREAKPOINTS.md) return 'md'
  if (width >= BREAKPOINTS.sm) return 'sm'
  return 'xs'
}

function getSnapshot() {
  if (typeof window === 'undefined') {
    return {
      width: BREAKPOINTS.lg,
      breakpoint: 'lg' as BreakpointKey,
      isMobile: false,
      isTablet: false,
      isDesktop: true,
    }
  }
  const width = window.innerWidth
  const breakpoint = getBreakpoint(width)
  return {
    width,
    breakpoint,
    isMobile: width < BREAKPOINTS.md,
    isTablet: width >= BREAKPOINTS.md && width < BREAKPOINTS.lg,
    isDesktop: width >= BREAKPOINTS.lg,
  }
}

export function useBreakpoint() {
  const [state, setState] = useState(getSnapshot)

  useEffect(() => {
    const onResize = () => setState(getSnapshot())
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return state
}
